import { Layout } from "@/components/Layout";
import { Seo } from "@/components/Seo";
import { useSettings } from "@/context/SettingsContext";

export default function StaticPage({ type }) {
  const { settings } = useSettings();
  const isPrivacy = type === "privacy";
  return (
    <Layout>
      <Seo title={`${isPrivacy ? "Privacy Policy" : "Terms & Conditions"} | Mashiniya`} description={isPrivacy ? "How Mashiniya (Indra Sphere) handles buyer and seller information submitted through the platform." : "Terms and conditions for using the Mashiniya machinery and spare-parts discovery platform."} canonical={window.location.origin + (isPrivacy ? "/privacy" : "/terms")} />
      <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6 lg:px-8">
        <h1 className="font-display text-3xl font-extrabold text-slate-900">
          {isPrivacy ? "Privacy Policy" : "Terms & Conditions"}
        </h1>
        <div className="mt-6 space-y-4 text-slate-600">
          {isPrivacy ? (
            <>
              <p>Mashiniya ({settings.parent_company}) respects your privacy. This page explains how we handle information submitted through our platform.</p>
              <p>When you submit an enquiry or a sell request, we collect your name, contact number and message to connect you with the relevant seller. Buyer and seller contact details are kept private and are not publicly displayed.</p>
              <p>We do not sell your personal information. Enquiries are shared only with the concerned seller to facilitate a direct connection.</p>
              <p>For any privacy questions, contact us at {settings.email}.</p>
            </>
          ) : (
            <>
              <p>By using Mashiniya, you agree to the following terms.</p>
              <p>Mashiniya is a platform that helps buyers and sellers discover and connect with each other. Buyers should independently verify machine condition, ownership, documents, specifications, price, payment terms and other transaction details directly with the seller before completing any transaction.</p>
              <p>Mashiniya does not participate in payments, logistics or the actual sale of any machine. All listings are provided for informational purposes.</p>
              <p>Machine availability and prices are subject to change. Listings marked SOLD are retained for reference only.</p>
              <p>For any questions, contact us at {settings.email}.</p>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
}
